import {
  CLEAR_EQUIPMENT_HOLDING_PROFILE,
  DELETE_HOLDING_PROFILES,
  EQUIPMENT_PRODUCT_PROFILES_FETCH,
  EQUIPMENT_SERIAL_NUMBERS_FETCH,
  EQUIPMENTS_CLEAR_ENTITY,
  EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES,
  EQUIPMENTS_CLEAR_PAGINATION_INFO,
  EQUIPMENTS_FETCH_CATEGORIES,
  EQUIPMENTS_FETCH_EQUIPMENT,
  EQUIPMENTS_FETCH_EQUIPMENTS,
  EQUIPMENTS_FETCH_EQUIPMENTS_PIECES,
  EQUIPMENTS_FETCH_HOLDING_PROFILE,
  EQUIPMENTS_FETCH_HOLDING_PROFILES,
  EQUIPMENTS_FETCH_MODELS,
  EQUIPMENTS_FETCH_SUPPLIERS,
  EQUIPMENTS_SET_COUNTRIES,
  EQUIPMENTS_SET_EQUIPMENT_TO_EDIT,
  EQUIPMENTS_SET_PAGE,
  EQUIPMENTS_SET_REGIONS,
  EQUIPMENTS_SET_ROWS_PER_PAGE,
  EQUIPMENTS_SET_SEARCH_OBJECT,
  EQUIPMENTS_TRANSLATIONS
} from "../action-types/equipments-types";
import { EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES } from "../action-types/equipment-holding-profile";
import ColumnInterface from "../../interfaces/column";
import AppConstants from "../../AppConstants";

const columns: ColumnInterface[] = [
  { id: 'availability', label: 'Availability', align: 'left' },
  { id: 'approval', label: 'Approval Type', align: 'left' },
  { id: 'core', label: 'Core', align: 'left' },
  { id: 'category', label: 'Category', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'manufacturer', label: 'Manufacturer/Supplier', align: 'left' },
  { id: 'model', label: 'Model/Series', align: 'left' },
  { id: 'visible', label: 'Visible for Franchise', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'action', label: 'Actions' },
];

export const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  columns,
  loading: false,
  paginationConfig: {
    total: 8,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
  categories: [],
  suppliers: [],
  models: [],
  searchObject: {},
  regions: [],
  countries: [],
  global: [],
  entityToEdit: {},
  id: 0,
  equipmentHoldingProfiles: {},
  equipmentHoldingProfile: {
    availabilities: [],
  },
  equipmentsTranslations: [],
  serialNumbers: [],
  equipmentsHoldingProfiles: [],
};

export default function equipmentsReducer(state = initialState, action) {
  switch (action.type) {
    case EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.REQUEST:
    case EQUIPMENTS_FETCH_HOLDING_PROFILE.REQUEST:
    case EQUIPMENTS_TRANSLATIONS.REQUEST:
    case EQUIPMENT_SERIAL_NUMBERS_FETCH.REQUEST:
    case EQUIPMENTS_FETCH_EQUIPMENTS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EQUIPMENTS_FETCH_HOLDING_PROFILES.REQUEST:
      return {
        ...state,
        loading: true,
        equipmentHoldingProfiles: [],
      };
    case EQUIPMENTS_FETCH_EQUIPMENTS.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data.equipments],
        paginationConfig: {
          ...state.paginationConfig,
          total: action.payload.data.pagination.total,
        },
        loading: false,
      };
    case EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.SUCCESS:
      return {
        ...state,
        entitiesPieces: [...action.payload.data],
        loading: false,
      };
    case EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES:
      return {
        ...state,
        entitiesPieces: [],
        loading: false,
      };
    case EQUIPMENTS_FETCH_EQUIPMENTS.REJECTED:
    case EQUIPMENTS_FETCH_HOLDING_PROFILES.REJECTED:
    case EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    case EQUIPMENTS_FETCH_EQUIPMENT.REQUEST:
      return {
        ...state,
        entityLoaded: false,
      };
    case EQUIPMENTS_FETCH_EQUIPMENT.SUCCESS:
      return {
        ...state,
        entity: action.payload,
        entityLoaded: true,
      };
    case EQUIPMENTS_FETCH_EQUIPMENT.REJECTED:
      return {
        ...state,
        entityLoaded: true,
      };
    case EQUIPMENTS_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case EQUIPMENTS_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };
    case EQUIPMENTS_CLEAR_PAGINATION_INFO:
      return {
        ...state,
        paginationConfig: {
          page: 1,
          rowsPerPage: AppConstants.rowsPerPage,
          total: 0,
        },
      };
    case EQUIPMENTS_FETCH_CATEGORIES.SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
      };
    case EQUIPMENTS_FETCH_CATEGORIES.REQUEST:
    case EQUIPMENTS_FETCH_CATEGORIES.REJECTED:
      return {
        ...state,
        categories: [],
      };
    case EQUIPMENTS_FETCH_SUPPLIERS.SUCCESS:
      return {
        ...state,
        suppliers: action.payload.data,
      };
    case EQUIPMENTS_FETCH_SUPPLIERS.REQUEST:
    case EQUIPMENTS_FETCH_SUPPLIERS.REJECTED:
      return {
        ...state,
        suppliers: [],
      };
    case EQUIPMENTS_FETCH_MODELS.SUCCESS:
      return {
        ...state,
        models: action.payload,
      };
    case EQUIPMENTS_FETCH_MODELS.REQUEST:
    case EQUIPMENTS_FETCH_MODELS.REJECTED:
      return {
        ...state,
        models: [],
      };
    case EQUIPMENTS_SET_SEARCH_OBJECT:
      return {
        ...state,
        searchObject: { ...action.payload },
      };
    case EQUIPMENTS_SET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };
    case EQUIPMENTS_SET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
      };
    case EQUIPMENTS_SET_EQUIPMENT_TO_EDIT:
      return {
        ...state,
        entityToEdit: { ...action.payload },
      };
    case EQUIPMENTS_CLEAR_ENTITY:
      return {
        ...state,
        entityToEdit: {},
      };
    case DELETE_HOLDING_PROFILES.REQUEST:
      return {
        ...state,
      };
    case EQUIPMENT_HOLDING_PROFILE_REMOVE_TYPES:
      return {
        ...state,
        equipmentHoldingProfiles: { ...action.payload },
      };
    case EQUIPMENTS_FETCH_HOLDING_PROFILES.SUCCESS:
      return {
        ...state,
        equipmentHoldingProfiles: { ...action.payload.data },
      };
    case EQUIPMENTS_FETCH_HOLDING_PROFILE.SUCCESS:
      return {
        ...state,
        equipmentHoldingProfile: { ...action.payload.data.holdingProfile },
      };

    case EQUIPMENTS_TRANSLATIONS.SUCCESS:
      return {
        ...state,
        equipmentsTranslations: action.payload.data,
        loading: false,
      };
    case EQUIPMENTS_TRANSLATIONS.REJECTED:
    case EQUIPMENT_SERIAL_NUMBERS_FETCH.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case EQUIPMENTS_FETCH_HOLDING_PROFILE.REJECTED:
      return {
        ...state,
        equipmentHoldingProfile: {},
        loading: false,
      };
    case CLEAR_EQUIPMENT_HOLDING_PROFILE:
      return {
        ...state,
        equipmentHoldingProfile: {},
      };
    case EQUIPMENT_SERIAL_NUMBERS_FETCH.SUCCESS:
      return {
        ...state,
        serialNumbers: action.payload,
      };
    case EQUIPMENT_PRODUCT_PROFILES_FETCH.SUCCESS:
      return {
        ...state,
        equipmentsHoldingProfiles: action.payload.data,
      };
    default:
      return state;
  }
}
